import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bug",
  templateUrl: "./med-icon-bug.component.html",
})
export class MedIconBugComponent extends SvgMixinComponent {}
